module.exports = __webpack_public_path__ + "static/media/SupplyChain3.a4ed710b.png";